import WelcomeOptions from './WelcomeOptions';

export default WelcomeOptions;
